import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Card, Container, Stack, Heading, Text } from "@sanity/ui";
import { useState, useEffect } from "react";
const ERROR_TITLE = "Dev server stopped", ERROR_DESCRIPTION = "The development server has stopped. You may need to restart it to continue working.";
class ViteDevServerStoppedError extends Error {
  constructor() {
    super(ERROR_TITLE), this.name = "ViteDevServerStoppedError", this.ViteDevServerStoppedError = !0;
  }
}
const serverHot = import.meta.hot, isViteServer = (hot) => !!hot, useDetectViteDevServerStopped = () => {
  const $ = c(5), [devServerStopped, setDevServerStopped] = useState(!1);
  let t0;
  $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = () => setDevServerStopped(!0), $[0] = t0) : t0 = $[0];
  const markDevServerStopped = t0;
  let t1, t2;
  $[1] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    isViteServer(serverHot) && serverHot.on("vite:ws:disconnect", markDevServerStopped);
  }, t2 = [markDevServerStopped], $[1] = t1, $[2] = t2) : (t1 = $[1], t2 = $[2]), useEffect(t1, t2);
  let t3;
  return $[3] !== devServerStopped ? (t3 = {
    devServerStopped
  }, $[3] = devServerStopped, $[4] = t3) : t3 = $[4], t3;
}, ThrowViteServerStopped = () => {
  const {
    devServerStopped
  } = useDetectViteDevServerStopped();
  if (devServerStopped)
    throw new ViteDevServerStoppedError();
  return null;
}, DetectViteDevServerStopped = () => isViteServer(serverHot) ? /* @__PURE__ */ jsx(ThrowViteServerStopped, {}) : null, DevServerStoppedErrorScreen = () => /* @__PURE__ */ jsx(Card, { height: "fill", overflow: "auto", paddingY: [4, 5, 6, 7], paddingX: 4, sizing: "border", tone: "critical", children: /* @__PURE__ */ jsx(Container, { width: 3, children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
  /* @__PURE__ */ jsx(Heading, { children: ERROR_TITLE }),
  /* @__PURE__ */ jsx(Card, { border: !0, radius: 2, overflow: "auto", padding: 4, tone: "inherit", children: /* @__PURE__ */ jsx(Stack, { space: 4, children: /* @__PURE__ */ jsx(Text, { size: 2, children: ERROR_DESCRIPTION }) }) })
] }) }) });
export {
  DetectViteDevServerStopped,
  DevServerStoppedErrorScreen
};
//# sourceMappingURL=ViteDevServerStopped.mjs.map
